import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { CRMQuanHuyenClient, CRM_QuanHuyenDto } from '../../api-connector/sso-connector';
import { QuanHuyenService } from '../../services/quan-huyen.service';

@Component({
  selector: 'quan-huyen-control',
  templateUrl: './quan-huyen-control.component.html',
  styleUrls: ['./quan-huyen-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuanHuyenControlComponent),
      multi: true,
    }
  ]
})
export class QuanHuyenControlComponent extends BaseAutocompleteControl<CRM_QuanHuyenDto> implements OnInit {

  @Input() maTinhThanh?: string;
  @Input() showOld?: string;

  private loadedCode: string | null = null;

  constructor(
    private service: QuanHuyenService,
    private quanHuyenClient: CRMQuanHuyenClient
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Client-side filtering from service
   */
  protected fetchItems(searchValue: string): Observable<CRM_QuanHuyenDto[]> {
    return this.service.getAll().pipe(
      map(() => {
        if (!this.maTinhThanh) {
          return [];
        }
        return this.service.filterCRMWithTag(searchValue, this.maTinhThanh);
      })
    );
  }

  /**
   * Override writeValue to handle code-based loading
   */
  writeValue(code: string | CRM_QuanHuyenDto): void {
    if (!code) {
      this.control.setValue(null, { emitEvent: false });
      this.selectedItem = null;
      this.loadedCode = null;
      return;
    }

    if (code instanceof CRM_QuanHuyenDto) {
      this.control.setValue(code, { emitEvent: false });
      this.selectedItem = code;
      this.loadedCode = code.maQuanHuyen || null;
      return;
    }

    if (typeof code === 'string' && code !== this.loadedCode) {
      this.loadedCode = code || null;

      const cached = this.service.findByCode(code);
      if (cached) {
        this.control.setValue(cached, { emitEvent: false });
        this.selectedItem = cached;
      } else {
        this.quanHuyenClient.getDetail(code).subscribe(
          result => {
            this.control.setValue(result, { emitEvent: false });
            this.selectedItem = result;
          },
          error => {
            console.error('Error loading district:', error);
            this.control.setValue(null, { emitEvent: false });
            this.selectedItem = null;
          }
        );
      }
    }
  }

  getDisplayValue(item: CRM_QuanHuyenDto | null): string {
    const result = item?.tenQuanHuyen || '';
    if (item) {
      console.log('QuanHuyen getDisplayValue:', {
        tenQuanHuyen: item.tenQuanHuyen,
        tenTinhThanh: item.tenTinhThanh,
        result
      });
    }
    return result;
  }

  protected isValidItem(value: any): boolean {
    return value instanceof CRM_QuanHuyenDto;
  }

  /**
   * Use client-side filtering
   */
  protected useClientSideFilter(): boolean {
    return true;
  }
}
